import { render, staticRenderFns } from "./NewLocation.vue?vue&type=template&id=b1496104"
import script from "./NewLocation.vue?vue&type=script&lang=js"
export * from "./NewLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports